import powerOfTrustQuestions from './questions';
import outputDoc from './outputDoc';

const powerOfAttorney = {
  mainHeaders: {
    shortPainFree: 'Vorsorgeauftrag: kurz und schmerzfrei',
    madeIt: 'Ihr wirksamer Vorsorgeauftrag',
  },

  stepperInfo: [
    {
      label: 'Basisinformationen',
      title: 'Worum geht es?',
    },
    {
      label: 'Ihr Vorsorgeauftrag',
      title: 'Hinterlegen Sie Ihren Vorsorgeauftrag',
    },
  ],

  stepOne: {
    introParagraph:
      'Leider gibt es Situationen, die zu unserer Urteilsunfähigkeit führen können. Beispiele dafür sind schwere Unfälle oder Krankheiten wie Demenz',
    helperParagraph:
      'Wir empfehlen Ihnen daher, frühzeitig durch eine so genannte Patientenverfügung zu regeln, wer sich in einer solchen Situation wie um Sie kümmern und Sie auch rechtlich vertreten soll. Dies entlastet Ihre Angehörigen in einer ohnehin schwierigen Situation, da Ihre Wünsche klar formuliert sind.',
    helperParagraph2:
      'Fangen wir an: Dieser Abschnitt dauert nur etwa 5 Minuten. Wenn Sie eine Pause brauchen, können Sie jederzeit anhalten und zwischenspeichern..',
    questionSixTooltip:
      'In der Schweiz haben grundsätzlich beide Elternteile das Sorgerecht, weshalb Sie dies immer berücksichtigen sollten.',
    questions: powerOfTrustQuestions,
  },

  stepTwo: {
    introParagraph: 'Herzlichen Glückwunsch! Ihr Vorsorgeauftrag ist erstellt.',
    helperParagraph:
      'Der schwierigste Schritt ist nun getan. Laden Sie das Dokument runter, drucken Sie es aus und lesen Sie es sorgfältig durch, um zu sehen, ob es wirklich Ihren Wünschen entspricht. Wenn Sie zufrieden sind, empfehlen wir Ihnen, den Vorsorgeauftrag mit einer Person Ihres Vertrauens und Ihrer Familie zu besprechen.',
    helperParagraph2:
      'Es empfiehlt sich, den Vorsorgeauftrag bei einem Anwalt oder Notar zu hinterlegen, dieser kann den Aufbewahrungsort auf Ihren Wunsch beim Schweizerischen Testamentsregister (https://www.ztr.ch) registrieren.',
    contactForm: 'Kontaktformular',
    helperParagraph3:
      'Wenn Sie möchten, dass wir Ihnen helfen, nutzen Sie bitte unser Kontaktformular.',
    obligation1:
      'Der Vorsorgeauftrag ist eigenhändig zu errichten oder öffentlich zu beurkunden. Der eigenhändige Vorsorgeauftrag ist von der auftraggebenden Person von Anfang bis Ende von Hand niederzuschreiben, zu datieren und zu unterzeichnen.',
    obligation2:
      'Wenn Sie unsicher sind, kann Ihnen ein Anwalt oder ein Notar dabei helfen.',
    document: outputDoc,
    nextStepsTitle: 'Die nächsten Schritte:',
    nextStep1Title: 'Formvorschrift beachten:',
    nextStep1:
      'Schreiben Sie den Vorsorgeauftrag vollständig von Hand ab, datieren und unterschreiben Sie ihn. Alternativ können Sie den Vorsorgeauftrag von einer Notarin oder einem Notar öffentlich beurkunden lassen. Laden Sie das unterschriebene oder beglaubigte Dokument hier hoch.',
    nextStep2Title: 'Vertrauenspersonen informieren:',
    nextStep2:
      'Stellen Sie sicher, dass Ihre benannten Vertrauenspersonen wissen, wo der Vorsorgeauftrag aufbewahrt wird. Sie können ihnen einen Gastzugang bei „gut geregelt“ einrichten, damit sie im Ernstfall Zugriff auf das Dokument haben (hier klicken).',
    highlightText: 'hier klicken',
    nextStep3Title: 'Mit Familie besprechen:',
    nextStep3:
      'Besprechen Sie den Vorsorgeauftrag mit Ihrer Familie und den betroffenen Personen, damit im Fall der Fälle alle informiert sind.',
    highlightedText: {
      uploadDocument: 'Dokument hier hoch.',
      noterizeWithLawyer: 'Anwalt beglaubigen lassen',
    },
  },
};

export default powerOfAttorney;
